module.exports = __webpack_public_path__ + "grape_price_promise-d69fe.svg";